import { useContext, useDebugValue } from "react";
import AuthContext from "../AuthProvider.js";

const useAuth = () => {
  const { auth } = useContext(AuthContext);
  return useContext(AuthContext);
};

export default useAuth;
